module.exports = __webpack_public_path__ + "static/media/property-redress-logo.4151d2dd.svg";